// app.js (Optimized)
import AppHelpers from './app-helpers.js';

// twig may emit boolean settings as the literal "true"/"false" or as the
// stringified-boolean "1"/"0". Treat anything except an explicit "off" value
// as enabled.
function isFlagEnabled(v) {
  if (v === undefined || v === null) return false;
  if (typeof v === 'boolean') return v;
  const s = String(v).toLowerCase();
  return s !== '' && s !== 'false' && s !== '0' && s !== 'null' && s !== 'undefined';
}

class App extends AppHelpers {
  constructor() {
    super();
    window.app = this;
    this.wishlistListenersAttached = true;
    this.mobileMenuInitialized = false;
    this.closeListenersAttached = false;
    this._loadAnimeOnce = null;
    this._initializeLanguage();
  }

  _initializeLanguage() {
    salla.lang.onLoaded(() => {
      const translations = {
        'pages.products.copied': { ar: 'تم نسخ الكوبون:', en: 'Coupon copied:' },
        'pages.products.vuick_view': { ar: 'الرؤية السريعة', en: 'Quick View' },
        'pages.products.discountma': { ar: 'خصم', en: 'Sale' },
        'pages.products.wafr': { ar: 'وفر', en: 'Offer' },
                'pages.order.product_percent': { ar: 'أصلي 100%', en: '100% original' },
        'pages.products.load_error': { ar: 'حدث خطأ أثناء التحميل', en: 'An error occurred while loading' },
        'pages.products.loading': { ar: 'جاري التحميل...', en: 'Loading...' },
            'pages.search.loading': { ar: 'جارٍ البحث…', en: 'Searching…' },
    'pages.search.empty':   { ar: 'لا توجد نتائج.', en: 'No results found.' },
    'pages.search.idle':    { ar: 'اكتب :minChars أحرف على الأقل لبدء البحث', en: 'Type at least :minChars characters to start searching' },
        'pages.products.related_products': { ar: 'المنتجات المشابهة', en: 'Related Products' },
        'pages.products.add_to_wishlist': { ar: 'إضافة إلى المفضلة', en: 'Add to Wishlist' },
        'pages.order.quntatysold': { ar: 'قطعه تم شراؤها', en: 'Purchased Piece' },
        'pages.order.product_percent_txt': { ar: 'للمزيد من ', en: 'For more' },
        'pages.desciption.appBanner': { ar: 'تفاصيل المنتج', en: 'Product description' },
      };
      Object.entries(translations).forEach(([key, value]) => salla.lang.add(key, value));
    });
  }
  defer(callback) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback);
    } else {
      setTimeout(callback, 200);
    }
  }

  loadTheApp() {
    app.watchElements({
      tooltipToggleHover: '.tooltip-toggle--clickable',
      scrollBtn: '#scrollToTop',
      wppButton: '#wpp-link',
      btmnav: '#btomNav'
    });
    this.commonThings();
    if (isFlagEnabled(window.header_is_sticky)) {
      this.initiateStickyMenu();
    }
    requestAnimationFrame(() => this.loadOnPaint());
    this.defer(() => this.loadOnIdle());
    this.loadModalImgOnclick();
    salla.comment.event.onAdded(() => window.location.reload());
    this.log('Theme Loaded 🎉');
    this.status = 'ready';
    document.dispatchEvent(new CustomEvent('theme::ready'));
  }


  async loadOnPaint() {
    if (app.scrollBtn) this.Wh__up();
    if (app.btmnav) this.W__btm_nav();
    this.Wh__QuickBuy();

  }


  async loadOnIdle() {
    if (app.wppButton) {
      app.wppButton.addEventListener('click', async () => {
        const module = await import('./partials/modules.js');
        await module.handel_whats();
      });
    }

    this.initAddToCart();
    this.Wh__footer();
    this.initiateAdAlert();
    this.initiateDropdowns();
    this.initiateModals();
    this.Wh__handeladd();
    this.W_opensearch();
    if (isFlagEnabled(window.has_animation)) this.F__Animation();
    await this.setupDynamicImports();
  }
  async setupDynamicImports() {
    const prefetchOnHover = async (e) => {
      const btn = e.target.closest('[data-open="search-panel"]');
      if (!btn) return;
      await this.__ensureSearchMod();
      document.removeEventListener('pointerenter', prefetchOnHover, true); // مرّة واحدة
    };
    document.addEventListener('pointerenter', prefetchOnHover, true);
  }

  W_opensearch() {
    // تفويض كليك للفتح/الإغلاق + dynamic import عند الحاجة
    document.addEventListener('click', async (e) => {
      const openBtn = e.target.closest('[data-open="search-panel"]');
      const closeBtn = e.target.closest('[data-close="search-panel"]');

      if (openBtn) {
        e.preventDefault();
        const mod = await this.__ensureSearchMod();

        // init مرّة واحدة (idempotent)
        if (!this.__searchInited) {
          (mod.default?.init ?? mod.initSearchModal)({
            panelId: 'search-panel',
            minChars: 3,
            perPage: 12,
            sortBy: 'ourSuggest',
            type: 'keyword'
            // brands: [..], categories: [..], branches: [..]  // لو عندك فلاتر
          });
          this.__searchInited = true;
        }

        (mod.default?.open ?? mod.openSearchPanel)();
      }

      if (closeBtn) {
        e.preventDefault();
        if (!this.__searchModPromise) {
          // لسه الموديول ما اتحمّـلش: اقفل بأي طريقة بدائية
          const panel = document.getElementById('search-panel');
          if (panel) panel.classList.add('hidden');
          return;
        }
        const mod = await this.__ensureSearchMod();
        (mod.default?.close ?? mod.closeSearchPanel)();
      }
    });

    document.addEventListener('keydown', async (e) => {
      if (e.key !== 'Escape') return;
      const panel = document.getElementById('search-panel');
      if (!panel || panel.classList.contains('hidden')) return;

      if (!this.__searchModPromise) { panel.classList.add('hidden'); return; }
      const mod = await this.__ensureSearchMod();
      (mod.default?.close ?? mod.closeSearchPanel)();
    });
  }

  // ===== Helpers (تابعة للكلاس) =====
  __ensureSearchMod() {
    if (!this.__searchModPromise) {
      this.__searchModPromise = import('./partials/search.js');
    }
    return this.__searchModPromise;
  }


  async setupDynamicImports() {
    await this.initiateMobileMenu();

    salla.notify.setNotifier(async (message, type) => {
      if (!this.Swal) {
        const { default: Swal } = await import('sweetalert2');
        this.Swal = Swal;
      }
      if (typeof message === 'object') return this.Swal.fire(message).then(type);
      return this.Swal.fire({
        toast: true,
        position: salla.config.get('theme.is_rtl') ? 'top-start' : 'top-end',
        icon: type,
        title: message,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: toast => {
          toast.addEventListener('mouseenter', this.Swal.stopTimer);
          toast.addEventListener('mouseleave', this.Swal.resumeTimer);
        },
      });
    });

    const animeElements = document.querySelectorAll('[data-anime]');
    if (animeElements.length) {
      const observer = new IntersectionObserver(async (entries, observer) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            if (!this._loadAnimeOnce) {
              this._loadAnimeOnce = import('./partials/anime.js').then(({ default: Anime }) => {
                this.Anime = Anime;
              });
            }
            await this._loadAnimeOnce;
            animeElements.forEach(el => {
              if (el.dataset.anime) {
                this.anime(el, JSON.parse(el.dataset.anime));
              }
            });
            observer.disconnect();
            break;
          }
        }
      }, { threshold: 0.1 });
      animeElements.forEach(el => observer.observe(el));
    }

    const tooltipElements = document.querySelectorAll('.tooltip-toggle--clickable');
    if (tooltipElements.length) {
      tooltipElements.forEach(el => {
        this.onClick(el, async () => {
          if (!this.initTootTip) {
            const { default: initTootTip } = await import('./partials/tooltip.js');
            this.initTootTip = initTootTip;
            await initTootTip();
          }
        });
      });
    }
  }
  Wh__QuickBuy() { setTimeout(() => { let o = document.querySelectorAll(".s-add-product-button-main .s-add-product-button-mini-checkout"); if (0 === o.length) return; o.forEach(o => { if (o && o.shadowRoot) { let t = o.shadowRoot.querySelector(".s-fast-checkout-button"); t ? (t.style.borderRadius = "var(--border-custom)") : console.error("Button not found inside shadow root") } }) }, 2e3) }
async initiateMobileMenu(){if(this.mobileMenuInitialized)return;let e=document.querySelector("a[href='#mobile-menu']");if(e)try{let i=await this.isElementLoaded("#mobile-menu"),t=null,n=null;e.addEventListener("click",async e=>{e.preventDefault();try{if(!this.MobileMenu){let{default:l}=await import("mmenu-light");this.MobileMenu=l}if(t||(t=new this.MobileMenu(i,"(max-width: 4024px)",{slidingSubmenus:!1}),salla?.lang?.onLoaded(()=>{t.navigation({title:salla.lang.get("blocks.header.main_menu")||"القائمة الرئيسية"})}),n=t.offcanvas({position:salla?.config?.get("theme.is_rtl")?"right":"left"})),document.body.classList.add("menu-opened"),n.open(),!this.closeListenersAttached){let o=document.querySelectorAll(".close-mobile-menu");o.forEach(e=>{e.addEventListener("click",e=>{e.preventDefault(),document.body.classList.remove("menu-opened"),n.close()},{once:!0})}),this.closeListenersAttached=!0}}catch(a){console.error("خطأ في فتح القايمة:",a)}}),this.mobileMenuInitialized=!0}catch(l){console.warn("#mobile-menu:",l)}}
  W__btm_nav() {
    if (!app.btmnav) return;
    if (window.innerWidth <= 640) {
      const path = location.pathname;
      document.querySelectorAll('.nav__item a').forEach(link => {
        if (path === new URL(link.href).pathname) {
          link.closest('.nav__item').classList.add('active');
        } else {
          link.closest('.nav__item').classList.remove('active');
        }
      })
      setTimeout(() => {
        app.btmnav.classList.remove('opacity-0', 'translate-y-10');
        app.btmnav.classList.add('opacity-100', 'translate-y-0');
      }, 2000);
    }
  }
  Wh__up() {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 300) {
        app.scrollBtn.classList.add('opacity-100', 'translate-y-0', 'pointer-events-auto');
        app.scrollBtn.classList.remove('opacity-0', 'translate-y-4', 'pointer-events-none');
      } else {
        app.scrollBtn.classList.remove('opacity-100', 'translate-y-0', 'pointer-events-auto');
        app.scrollBtn.classList.add('opacity-0', 'translate-y-4', 'pointer-events-none');
      }
    }, { passive: true });

    app.scrollBtn.querySelector('.top-btn').addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  log(message) {
    salla.log(`ThemeApp(Raed)::${message}`);
    return this;
  }

  loadModalImgOnclick() {
    const links = document.querySelectorAll('.load-img-onclick');
    links.forEach(link => {
      this.onClick(link, event => {
        event.preventDefault();
        const modal = document.querySelector(`#${link.dataset.modalId}`);
        if (!modal) return;
        const img = modal.querySelector('img');
        if (!img.classList.contains('loaded')) {
          img.src = img.dataset.src;
          img.classList.add('loaded');
        }
        modal.open?.();
      });
    });
  }

  commonThings() {
    this.cleanContentArticles('.content-entry');
  }

  cleanContentArticles(selector) {
    const articles = document.querySelectorAll(selector);
    articles.forEach(article => {
      article.innerHTML = article.innerHTML.replace(/\ /g, ' ');
    });
  }

  async colorTheme() {
    const toggle = document.getElementById('toggle_theme');
    if (!toggle) return;

    const root = document.documentElement;
    const savedTheme = localStorage.getItem('theme');

    if (savedTheme === 'dark') {
      root.setAttribute('data-theme', 'dark');
      toggle.checked = true;
    } else {
      root.setAttribute('data-theme', 'light');
      toggle.checked = false;
    }

    toggle.addEventListener('change', () => {
      const isDark = toggle.checked;
      const theme = isDark ? 'dark' : 'light';
      root.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);
    });
  }

 async F__Animation() {
    if (!('IntersectionObserver' in window)) return;
    const options = { rootMargin: '80px 0px', threshold: 0.12 };
    const seen = new WeakSet();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry, idx) => {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          const delay = (idx % 6) * 0.08;
          entry.target.style.setProperty('--delay', `${delay}s`);
          entry.target.classList.add('will-animate');
          requestAnimationFrame(() => {
            entry.target.classList.add('animating');
            entry.target.addEventListener('animationend', () => {
              entry.target.classList.remove('reveal', 'animating', 'will-animate');
              entry.target.style.removeProperty('--delay');
            }, { once: true });
          });
          io.unobserve(entry.target);
        }
      });
    }, options);

    document.querySelectorAll('.reveal').forEach(el => io.observe(el));

    new MutationObserver((muts) => {
      muts.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.classList?.contains('reveal')) {
            io.observe(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  async isElementLoaded(selector, timeout = 5000) {
    const el = document.querySelector(selector);
    if (el) return el;
    return new Promise((resolve, reject) => {
      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          observer.disconnect();
          resolve(el);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => {
        observer.disconnect();
        reject(new Error('Element not found'));
      }, timeout);
    });
  }

  copyToClipboard(event) {
    event.preventDefault();
    const btn = event.currentTarget;
    navigator.clipboard.writeText(btn.dataset.content).then(() => {
      this.toggleElementClassIf(btn, 'copied', 'code-to-copy', () => true);
      setTimeout(() => this.toggleElementClassIf(btn, 'code-to-copy', 'copied', () => true), 1000);
    }).catch(() => this.log('Clipboard copy failed'));
  }

  initiateStickyMenu() {
    const header = this.element('#mainnav');
    if (!header) return;

    const inner = header.querySelector('.inner');
    if (!inner) return;

    // Cache class checks
    const isIndexAbsolute = header.classList.contains('index_abso');

    // Set header height based on inner content
    const setHeight = () => {
      header.style.height = `${inner.clientHeight}px`;
    };

    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          const innerHeight = inner.clientHeight;
          const headerTop = header.offsetTop + innerHeight;

          const isPastTop = scrollY >= headerTop;
          const isScrolled = scrollY >= 200;

          header.classList.toggle('fixed-pinned', isPastTop);
          header.classList.toggle('animated', isPastTop);
          header.classList.toggle('fixed-header', isScrolled);

          if (isIndexAbsolute) {
            const isAboveThreshold = scrollY < 200;
            header.classList.toggle('absolute__header', isAboveThreshold);
            header.classList.toggle('absolute', isAboveThreshold);
          }

          ticking = false;
        });
        ticking = true;
      }
    };

    // Initial setup
    window.addEventListener('load', setHeight, { once: true });
    window.addEventListener('resize', app.debounce(setHeight, 100));
    window.addEventListener('scroll', handleScroll, { passive: true });
  }


  async initiateAdAlert() {
    const ad = this.element('.salla-advertisement');
    if (!ad || salla.storage.get(`statusAd-${ad.dataset.id}`)) return;

    ad.classList.remove('hidden');
    this.onClick('.ad-close', async event => {
      event.preventDefault();
      salla.storage.set(`statusAd-${ad.dataset.id}`, 'dismissed');
      if (!this._loadAnimeOnce) {
        this._loadAnimeOnce = import('./partials/anime.js').then(({ default: Anime }) => {
          this.Anime = Anime;
        });
      }
      await this._loadAnimeOnce;
      this.Anime({
        targets: ad,
        opacity: [1, 0],
        height: [ad.clientHeight, 0],
        duration: 300,
        easing: 'easeInOutQuad',
      });
    });
  }
  Wh__handeladd() {
    setTimeout(() => {
      const adEl = this.element('salla-advertisement');
      if (!adEl) return;

      const innerWrapper = this.element('#min_content');
      if (adEl && innerWrapper && innerWrapper.parentNode) {
        adEl.style.display = 'block';
        innerWrapper.parentNode.insertBefore(adEl, innerWrapper);
      }
    }, 500);
  }


  initiateDropdowns() {
    const triggers = document.querySelectorAll('.dropdown__trigger');
    triggers.forEach(btn => {
      this.onClick(btn, () => {
        const dropdown = btn.parentElement;
        const isOpen = dropdown.classList.toggle('is-opened');
        document.body.classList.toggle('dropdown--is-opened', isOpen);
        if (isOpen) {
          const closeHandler = ({ target: el }) => {
            if (!el.closest('.dropdown__menu') || el.classList.contains('dropdown__close')) {
              dropdown.classList.remove('is-opened');
              document.body.classList.remove('dropdown--is-opened');
              window.removeEventListener('click', closeHandler);
            }
          };
          window.addEventListener('click', closeHandler);
        }
      });
    });
  }

  initiateModals() {
    this.onClick('[data-modal-trigger]', ({ target }) => {
      const modal = `#${target.dataset.modalTrigger}`;
      this.removeClass(modal, 'hidden');
      setTimeout(() => this.toggleModal(modal, true));
    });
    this.onClick('[data-close-modal]', ({ target }) => this.toggleModal(`#${target.dataset.closeModal}`, false));
  }

  toggleModal(id, isOpen) {
    this.toggleClassIf(`${id} .s-salla-modal-overlay`, 'ease-out duration-300 opacity-100', 'opacity-0', () => isOpen)
      .toggleClassIf(
        `${id} .s-salla-modal-body`,
        'ease-out duration-300 opacity-100 translate-y-0 sm:scale-100',
        'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95',
        () => isOpen
      )
      .toggleElementClassIf(document.body, 'modal-is-open', 'modal-is-closed', () => isOpen);
    if (!isOpen) setTimeout(() => this.addClass(id, 'hidden'), 350);
  }

  initiateCollapse() {
    const triggers = document.querySelectorAll('.btn--collapse');
    triggers.forEach(trigger => {
      const content = document.querySelector(`#${trigger.dataset.show}`);
      if (!content) return;
      let isOpen = false;

      this.onClick(trigger, async () => {
        isOpen = !isOpen;
        this.toggleElementClassIf([content, trigger], 'is-closed', 'is-opened', () => isOpen);
        if (!this._loadAnimeOnce) {
          this._loadAnimeOnce = import('./partials/anime.js').then(({ default: Anime }) => {
            this.Anime = Anime;
          });
        }
        await this._loadAnimeOnce;
        this.Anime({
          targets: content,
          height: isOpen ? content.scrollHeight : 0,
          opacity: isOpen ? [0, 1] : [1, 0],
          duration: 225,
          easing: 'easeOutQuart',
        });
      });
    });
  }

  anime(selector, options = null) {
    if (!this.Anime) {
      console.warn('Anime module not loaded yet. Please wait for the element to be visible.');
      return;
    }
    const animeInstance = new this.Anime(selector, options);
    return options === false ? animeInstance : animeInstance.play();
  }

  initAddToCart() {
    salla.cart.event.onUpdated(summary => {
      const totalEls = document.querySelectorAll('[data-cart-total]');
      const countEls = document.querySelectorAll('[data-cart-count]');
      totalEls.forEach(el => (el.innerHTML = salla.money(summary.total)));
      countEls.forEach(el => (el.innerText = salla.helpers.number(summary.count)));
    });

    salla.cart.event.onItemAdded(async (response, prodId) => {
      const cartSummary = this.element('salla-cart-summary');
      const productImg = this.element(`#product-${prodId} img`);
      if (cartSummary && productImg) {
        if (!this._loadAnimeOnce) {
          this._loadAnimeOnce = import('./partials/anime.js').then(({ default: Anime }) => {
            this.Anime = Anime;
          });
        }
        await this._loadAnimeOnce;
        cartSummary.animateToCart(productImg);
      }
    });
  }

  Wh__footer() {
    const items = document.querySelectorAll(".Wh__fot_ac_i_h");
    items.forEach(e => {
      this.onClick(e, () => {
        let t = e.nextElementSibling;
        if (t.style.maxHeight) {
          t.style.maxHeight = null;
          e.classList.remove("active");
        } else {
          t.style.maxHeight = t.scrollHeight + "px";
          e.classList.add("active");
        }
      });
    });
  }
}

salla.onReady(() => new App().loadTheApp());